import React from 'react';
import './Header.css';
import hlogo from './../../images/ICON/logo2.png';

const Header = () => {
    return (
        <div>
           <section className='Header-top'>
                <div className='container'>
                    <div className='row py-3'>
                        <div className='col-lg-4 text-left'>
                            <img src={hlogo} alt="img" class="img-fluid" />
                        </div>
                        <div className='col-lg-8'>
                            <nav class="navbar navbar-expand-lg navbar-light">
                                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                    <span class="navbar-toggler-icon"></span>
                                </button>
                            
                                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                                    <ul class="navbar-nav">
                                        <li class="nav-item">
                                            <a class="nav-link" href="#"><i class="fa fa-cart-plus"></i></a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="#">Login <span class="sr-only">(current)</span></a>
                                        </li>
                                        <li class="nav-item signup">
                                            <a class="nav-link" href="#">Sign up</a>
                                        </li>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
           </section>

           <section  className='banner'>
                <div className='container'>
                    <div className='row'>
                       <div className='col-lg-12 content'>
                            <h2>Best food waiting for your belly</h2>
                       </div>
                       <div className='search'>
                            <input type="text"  placeholder='Search food items'/>
                            <button>Search</button>
                       </div>
                    </div>
                </div> 
           </section>
        </div>
    );
};

export default Header;